import React, {useCallback, useEffect, useState} from 'react'

export function useSmallSize() {
  const [isSmallSize, setIsSmallSize] = useState(window.innerWidth < 768);

  const sizeChangeHandler = useCallback(() => {
    if (window.innerWidth < 768) {
      setIsSmallSize(true);
    } else {
      setIsSmallSize(false);
    }
  }, [setIsSmallSize]);

  useEffect(() => {
    sizeChangeHandler();
    window.addEventListener("resize", sizeChangeHandler);
    return () => {
      window.removeEventListener("resize", sizeChangeHandler);
    };
  }, []);

  return isSmallSize;
}